module.exports = __webpack_public_path__ + "img/simple_consult_bg.2db524b1.png";